import {
    TemplateTextDynamic,
} from '../modules/email/email-editor/template-text-plugin/TemplateTextConsts';

export const Tooltips = {
    [TemplateTextDynamic.employerRepLinkedin]: 'EDITOR_AUTOTEXT_MISSING_VALUE_RECRUITER_LINKEDIN_PROFILE_TOOLTIP',
    [TemplateTextDynamic.employerRepPhone]: 'EDITOR_AUTOTEXT_MISSING_VALUE_RECRUITER_PHONE_TOOLTIP',
    [TemplateTextDynamic.employerRepJobTitle]: 'EDITOR_AUTOTEXT_MISSING_VALUE_RECRUITER_JOB_TITLE_TOOLTIP',
    [TemplateTextDynamic.employerLinkedin]: 'EDITOR_AUTOTEXT_MISSING_VALUE_EMPLOYER_COMPANY_LINKEDIN_TOOLTIP',
    default: 'EDITOR_AUTOTEXT_MISSING_VALUE_TOOLTIP',
};
